import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
import { faSuitcaseRolling } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DateRangeSelector from '../Flights/Dropdown/DateSelector'
import moment from 'moment'
import RoomsGuests from '../Flights/Dropdown/RoomsGuests'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import SearchDropdown from '../Flights/Dropdown/SearchDropdown'
import { City } from 'country-state-city'
import SwiperComponent from '../../component/CustomSlider/SwiperComponent'
import EndDateSelector from '../Flights/Dropdown/endDateSelector'
const Holidays = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [guestCounterOpen, setGuestCounterOpen] = useState(false)
  const [tripType, setTripType] = useState('Domestic')
  const [success, setSuccess] = useState(false)
  const [endOpen, setDateEndOpen] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Holidays/HolidaysImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    fetch('/PackageJson/Holidays/HolidaysForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    departureDate: '',
    rooms: 0,
    adults: 0,
    children: 0,
    city: '',
    returnDate: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const totalTravelers = formData.rooms + formData.adults + formData.children
  const handleChangeTripType = event => {
    setTripType(event.target.value)
  }
  const dispatch = useDispatch()
  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Holidays',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      EndDate: moment(formData.returnDate).format('DD MMM YYYY'),
      Adult: formData.adults,
      Child: formData.children,
      Infant: formData.rooms,
      TypeDomestic: tripType,
      City: formData.city
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        adults: 0,
        children: 0,
        infants: 0,
        travelClass: '',
        departureDate: '',
        returnDate: '',
        city: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }
  const handleCitySelect = selectedCity => {
    setFormData(prevState => ({
      ...prevState,
      city: selectedCity
    }))
  }

  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  const handleOnchangeEndOpen = item => {
    setFormData(prevState => ({
      ...prevState,
      returnDate: item.selection.startDate
    }))
  }

  const handleOnClick = () => {}
  return (
    <div>
      <div className='hotels Holidays'>
        <div
          style={{
            height: '',
            backgroundImage: `url(${flightsForm[0]?.displayBackground})`,
            backgroundPosition: 'center',
            backgroundSize: 'Cover',
            backgroundRepeat: 'no-repeat',
            padding: '80px 0px'
          }}
          className='product-container'
        >
          <div className='container'>
            <div className='product-area'>
              <p>Book Domestic and International Holiday Packages</p>
              <form onSubmit={handleSubmit}>
                <div className='radio-group'>
                  <label
                    className={`radio-label ${
                      tripType === 'Domestic' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='Domestic'
                      checked={tripType === 'Domestic'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    Domestic
                  </label>

                  <label
                    className={`radio-label ${
                      tripType === 'International' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='International'
                      checked={tripType === 'International'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    International
                  </label>
                </div>
                <div className='row'>
                  <div className='col-lg-4 col-md-12 col-sm-12'>
                    <div className='search-input-box flight-from'>
                      <label className='form-label'>City</label>

                      <SearchDropdown
                        data={City.getAllCities()}
                        placeholder=''
                        value={formData.city}
                        formData={formData}
                        onSelect={handleCitySelect}
                      />
                    </div>
                  </div>
                  <div className='col-lg-8 col-md-12 col-sm-12'>
                    <div className='form-group'>
                      <div className='subContent'>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateRangeOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label
                            onClick={() => setDateRangeOpen(true)}
                            className='form-label'
                          >
                            Check-In
                          </label>
                          <input
                            onClick={() => setDateRangeOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              formData.departureDate
                                ? moment(formData.departureDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.departureDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.departureDate
                                ? moment(formData.departureDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                          <DateRangeSelector
                            dateRangeOpen={dateRangeOpen}
                            setDateRangeOpen={setDateRangeOpen}
                            handleOnchangeDate={handleOnchangeDate}
                          />
                        </div>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateEndOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label className='form-label'>Check-Out</label>
                          <input
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              formData.returnDate
                                ? moment(formData.returnDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.returnDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.returnDate
                                ? moment(formData.returnDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                          <EndDateSelector
                            formData={formData}
                            dateRangeOpen={endOpen}
                            setDateRangeOpen={setDateEndOpen}
                            handleOnchangeDate={handleOnchangeEndOpen}
                          />
                        </div>
                        <div className='search-input-box room-box'>
                          <div
                            onClick={() => setGuestCounterOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label
                            onClick={() => setGuestCounterOpen(true)}
                            className='form-label'
                          >
                            Guests
                          </label>
                          <input
                            onClick={() => setGuestCounterOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={totalTravelers === 0 ? '' : totalTravelers}
                            placeholder=''
                            required
                          />
                          <RoomsGuests
                            setGuestCounterOpen={setGuestCounterOpen}
                            guestCounterOpen={guestCounterOpen}
                            formData={formData}
                            setFormData={setFormData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-7 col-md-12 col-12 enquiry-form'>
                    <div className='row'>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='full_name'
                            placeholder='Full Name'
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='contact'
                            placeholder='Mobile Number'
                            pattern='^\d*$'
                            value={formData.contact}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='email'
                            placeholder='Email ID'
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          <input
                            type='hidden'
                            name='product_type'
                            value='hotels'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-5 col-md-12 col-12'>
                    <div className='recent-box'>
                      <div className='recent-head'>Recent Searches</div>
                      <ul className='recent-list'></ul>
                    </div>
                  </div>
                </div>
                <div className='button-center'>
                  <button type='submit' className='btn search-btn'>
                    <FontAwesomeIcon
                      icon={faSuitcaseRolling}
                      className='planeIcon'
                    />

                    <span className='button-text'>ENQUIRE NOW</span>
                  </button>
                </div>
              </form>
              {success && (
                <div className='success-popup'>Thank you for your enquiry!</div>
              )}
            </div>
          </div>
        </div>
        <SliderImages data={sliderImages[0]?.displayImages || []} />
        <SwiperComponent
          destinations={sliderImages[0]?.destinationsImages || []}
          onSelect={handleOnClick}
        />
      </div>
    </div>
  )
}
export default Holidays
